import React from "react";
import { SmartForm } from "./SmartForm";
import { SmartFormField } from "./SmartFormField";
import { FieldsAction } from "./useSmartForm";


export const SmartFormContext = React.createContext<SmartForm | null>(null);
export const FieldRegistrationContext = React.createContext<{
  fields: SmartFormField[];
  dispatch: React.Dispatch<FieldsAction>;
}>({fields: [], dispatch: () => {}});
